'use client';

import { Container } from '@veranda/shared/components/container';
import {
  type FilterOptions,
  ProductListingFilterSheet,
  ProductListingSortSelect,
  type SortOption,
  useProductListingFilters,
} from '@veranda/shared/components/pages/product-listing';
import {
  type ProductListingPageBaseProps,
  buildFilterOptions,
  usePrefetchProductListingProducts,
} from '@veranda/shared/components/pages/product-listing/client';
import { buttonVariants } from '@veranda/shared/components/ui/button';
import { cn } from '@veranda/shared/lib';
import { useTransition } from 'react';

export function FilterBar({
  slug,
  data,
  filterOptions,
}: {
  slug: string;
  data: ProductListingPageBaseProps;
  filterOptions: FilterOptions[];
}) {
  const prefetchSort = usePrefetchProductListingProducts();
  const [_, startTransition] = useTransition();
  const { filterValues } = useProductListingFilters({
    filterOptions,
    startTransition,
  });

  function prefetch(sort: SortOption) {
    prefetchSort({
      slug,
      currentPage: 1,
      sort,
      settings: data.settings,
      filterValues: filterValues,
    });
  }

  const cleanedFilterOptions = buildFilterOptions(data);

  if (!filterOptions.length) return null;

  return (
    <nav className="relative flex h-[var(--product-listing-filter-bar-height)] items-center justify-between gap-12 bg-brand-gray text-primary">
      <Container className="w-full">
        <div className="flex w-full items-center justify-between">
          <ProductListingFilterSheet
            filterOptions={cleanedFilterOptions}
            closeButtonClassName={cn(buttonVariants(), 'w-full')}
            className="text-primary [--color:var(--color-brand-burgundy)]"
          />
          <ProductListingSortSelect
            prefetchSort={prefetch}
            defaultSort={data.sortOrder}
            className="text-primary [--color:var(--color-brand-burgundy)]"
          />
        </div>
      </Container>
    </nav>
  );
}
